import axios from "axios";
import API from "../_helpers/endpointService";

export const getOPA_ListView = (data, id) => {

  let apiUrl = API.OPA_LISTVIEW + '?projectId=' + id + '&Activity=' + data.Activity + '&PlannedDateFrom=' + data.PlannedDateFrom + '&PlannedDateTo=' + data.PlannedDateTo + '&CompletionDateFrom=' + data.CompletionDateFrom + '&CompletionDateTo=' + data.CompletionDateTo + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;

  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,

    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "OPA_LISTVIEW", data: response.data });
        }
        else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
      });
  };
};
export const addOPA = (data) => {
  let apiUrl = API.OPA_LISTVIEW;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "OPA_Add", data: response.data })
        } else {

        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const getOPAActivity = (data) => {

  let apiUrl = API.OPA_ACTIVITY;
  return (dispatch) => {
    axios({
      method: "get",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "OPA_ACTIVITY", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const putOPA = (data, id) => {
  if (data.CompletionDate == "") {
    data.CompletionDate = null;
  }
  let apiUrl = API.OPA_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "OPAEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const gethistorylogOPA = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=OperationPlanning'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const geteditopainfo = (data, id) => {
  let apiUrl = API.OPA_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "OPAEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const deletemultiOPA = (data, id) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }
  let apiUrl = API.OPA_LISTVIEW + '/ids?' + ids;
  return (dispatch) => {
    axios({
      method: "delete",
      url: apiUrl,

    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {

        }
      });
  };
};
export const deleteOPA = (id, modify) => {

  let apiUrl = API.OPA_LISTVIEW + '/' + id + '?modify=' + modify
  return (dispatch) => {
    axios({
      method: "delete",
      url: apiUrl,

    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {

        }
      });
  };
};